import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';
import { API_URL } from '../config';

const WhatsAppButton = () => {
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/contact-infos`);
        if (response.data?.data && response.data.data.length > 0) {
          const phone = response.data.data[0].phone;
          setPhoneNumber(phone || '');
        }
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };

    fetchContactInfo();
  }, []);

  const handleWhatsAppClick = () => {
    if (phoneNumber) {
      // Telefon numarasından tüm boşlukları ve özel karakterleri kaldır
      const cleanNumber = phoneNumber.replace(/\D/g, '');
      const whatsappUrl = `https://wa.me/${cleanNumber}`;
      window.open(whatsappUrl, '_blank');
    }
  };

  // Telefon numarası yoksa butonu gösterme
  if (!phoneNumber) return null;

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 z-50 flex items-center justify-center hover:scale-110"
      aria-label="WhatsApp ile iletişime geç"
    >
      <FaWhatsapp className="text-2xl" />
    </button>
  );
};

export default WhatsAppButton;
